export default __webpack_public_path__ + "static/media/bg-1.a5e64440.jpg";